module.exports = __webpack_public_path__ + "img/bigflower.74ef9c17.png";